// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import components
import Navigation from './components/Navigation';
import HomePage from './pages/Home';
import AboutPage from './pages/About';
import SkillsPage from './pages/Skills';
import ProjectsPage from './pages/Projects';
import ContactForm from './pages/Contact';
import Footer from './components/Footer';

// Import individual case studies
import CloudAutomationCaseStudy from './case-studies/CloudAutomationCaseStudy';
import OklahomaModernizationCaseStudy from './case-studies/OklahomaModernizationCaseStudy';
import AwsMigrationCaseStudy from './case-studies/AwsMigrationCaseStudy';
import DataVisualizationCaseStudy from './case-studies/DataVisualizationCaseStudy';

// Import global styles
import './styles/global.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/skills" element={<SkillsPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/contact" element={<ContactForm />} />
            
            {/* Case Study Routes */}
            <Route path="/projects/cloud-automation" element={<CloudAutomationCaseStudy />} />
            <Route path="/projects/gcp-oklahoma" element={<OklahomaModernizationCaseStudy />} />
            <Route path="/projects/aws-migration" element={<AwsMigrationCaseStudy />} />
            <Route path="/projects/data-visualization" element={<DataVisualizationCaseStudy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;